import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://dashamajig.chibitronics.com/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

function authHeaders() {
  const token = localStorage.getItem('token')
  if (!token) return {}
  return { Authorization: `Bearer ${token}`, 'X-Auth-Token': token }
}

export default {
  /** Pick up Google OAuth session from HttpOnly cookie after redirect to home (no token in URL). */
  claimGoogleSession() {
    return apiClient.get('/auth/google/session', { withCredentials: true })
  },

  /** Contractor / manual login (username + password). */
  login(username, password) {
    return apiClient.post('/authenticate', { username, password })
  },

  changePassword({ current_password, password, password_confirmation }) {
    return apiClient.patch(
      '/password',
      { current_password, password, password_confirmation },
      { headers: authHeaders() }
    )
  }
}
